import { useMutation } from "@apollo/client";
import { useState } from "react";
import useUpdateGroceryListFromRemovingMeal from "./useUpdateGroceryListFromRemovingMeal";
import useUpdateGroceryListFromAddingMeal from "./useUpdateGroceryListFromAddingMeal";

const useUpdateGroceryListFromServingSize = () => {
  const [loading, setLoading] = useState(false);
  const { updatingGroceryListFromRemovingMeal, updateGroceryListFromRemovingMeal } = useUpdateGroceryListFromRemovingMeal();
  const { updatingGroceryListFromAddingMeal, updateGroceryListFromAddingMeal } = useUpdateGroceryListFromAddingMeal();

  // const [updateGroceryListFromServingSize] = useMutation(UPDATE_GROCERY_LIST_FROM_SERVING_SIZE, {})
  const updateGroceryListFromServingSize = async (addedMealReturnData: any[]) => {
    setLoading(true);
    const mealId = addedMealReturnData?.[0]?.id;
    await updateGroceryListFromRemovingMeal({mealId});
    await updateGroceryListFromAddingMeal(addedMealReturnData)
    setLoading(false);


  }

  return {
    updatingGroceryListFromServingSize: loading,
    updateGroceryListFromServingSize
  };
}

export default useUpdateGroceryListFromServingSize